import React from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import Toolbar from 'components/Toolbar/Toolbar';

const InterfaceCompressionToolbar = ({
  title = '', isFetching, refetch, backLink
}) => (
  <Toolbar
    title={title}
    backLink={backLink}
    action={isFetching ? (
      <div style={{
        height: 48, width: 48, display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}
      >
        <CircularProgress size={22} />
      </div>
    ) : (
      <Tooltip title="Sync">
        <IconButton
          onClick={(e) => {
            e.preventDefault();
            refetch();
          }}
        >
          <RefreshIcon />
        </IconButton>
      </Tooltip>
    )}
  />
);
export default InterfaceCompressionToolbar;
